import { PreloadingStrategy, Route } from '@angular/router';
import { Observable } from 'rxjs';

/**
 * IntentPreloadingStrategy — NO precarga nada por su cuenta.
 *
 * Angular llama a `preload(route, load)` para cada ruta lazy una vez que
 * termina la navegación inicial. Esta estrategia devuelve siempre sin hacer
 * nada, dejando la precarga en manos de `PreloadOnIntentDirective`, que pide
 * el chunk cuando el usuario pasa el mouse o enfoca un enlace.
 *
 * ── Por qué no `PreloadAllModules` ────────────────────────────────────────
 *
 * `PreloadAllModules` dispara la descarga de los 28 chunks `loadComponent`
 * justo después del arranque. Entre ellos está el visor, que arrastra
 * `@arcgis/core` (26 archivos del proyecto lo importan). El resultado es que
 * durante los primeros segundos el navegador compite por el ancho de banda
 * con decenas de MB ajenos a lo que el usuario está haciendo, y todos los
 * enlaces se perciben lentos a la vez.
 *
 * Con la precarga por intención se descarga solo lo que el usuario va a
 * visitar, y con antelación suficiente para que el clic sea instantáneo.
 */
export class IntentPreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, fn: () => Observable<any>): Observable<any> {
    // Intencionalmente vacío: la precarga es responsabilidad de la directiva.
    return new Observable<void>();
  }
}